import { isIE } from "@schoolbelle/common/functions";
let arrToolbarButtons:any = []

/*
if(isIE()) {
  arrToolbarButtons = [
      'fullscreen','bold','italic','underline','strikeThrough','|',
      'custom_fontsize_dropdown','color','|',
      'paragraphFormat','align','formatOL','formatUL','outdent','indent','|',
      'insertLink','insertVideo','insertTable','emoticons','|',
      'undo','redo','|',
      'save','load','|',
      'custom_translation_dropdown',
  ]
} else {
  arrToolbarButtons = [
    'fullscreen','bold','italic','underline','strikeThrough','|',
    'custom_fontsize_dropdown','color','|',
    'paragraphFormat','align','formatOL','formatUL','outdent','indent','|',
    'insertLink','insertFile','insertImage','insertVideo','insertTable','emoticons','|',
    'undo','redo','|',
    'save','load','|',
    'custom_translation_dropdown',
  ]
}
*/

//
arrToolbarButtons = [
  'fullscreen','bold','italic','underline','strikeThrough','|',
  'custom_fontsize_dropdown','color','|',
  'paragraphFormat','align','formatOL','formatUL','outdent','indent','|',
  'insertLink','insertFile','insertImage','insertVideo','insertTable','emoticons','|',
  'undo','redo','|',
  'save','load','|',
  'custom_translation_dropdown',
]


export const froalaOptions = {
  key:'AA9A6C4A4xC2D2E2A1A29B4A3A8C1E1sg1Ti1LXd2URVJh1DWXG==',
  zIndex: 1000,
  placeholderText: 'Enter text.',
  language: 'ko',
  heightMin: '100vh',
  imageUpload: true,
  imagePaste: false,
  imageOutputSize:true,
  // imageInsertButtons:['imageBack', '|', 'imageUpload', 'imageByURL'],
  videoInsertButtons: [
    'videoBack',
    '|',
    // 'videoUpload',
    'videoByURL',
    'videoEmbed'
  ],
  //
  videoDefaultWidth: 800,
  videoUpload: true,
  videoTextNear: true,
  videoEditButtons: ['videoAlign', 'videoSize', '|', 'videoRemove'],  
  fileUpload: true,
  linkEditButtons: ['linkOpen', 'linkEdit', 'linkRemove'],
  linkAlwaysBlank: true,
  linkInsertButtons: ['linkBack'],
  imageEditButtons: ['imageAlign','imageSize', '|', 'imageRemove'],
  tableEditButtons: ['tableRows', 'tableColumns', 'tableCells', '|', 'tableRemove'],
  colorsHEXInput: false,
  colorsText:[
    '#61BD6D', '#1ABC9C', '#54ACD2', '#2C82C9', '#9365B8', '#475577', '#CCCCCC',
    '#41A85F', '#00A885', '#3D8EB9', '#2969B0', '#553982', '#28324E', '#111',
    '#F7DA64', '#FBA026', '#EB6B56', '#E25041', '#A38F84', '#EFEFEF', '#FEFEFE',
    '#FAC51C', '#F37934', '#D14841', '#B8312F', '#7C706B', '#D1D5D8', 'REMOVE'
  ],  
  colorsBackground: [
    '#61BD6D', '#1ABC9C', '#54ACD2', '#2C82C9', '#9365B8', '#475577', '#CCCCCC',
    '#41A85F', '#00A885', '#3D8EB9', '#2969B0', '#553982', '#28324E', '#000000',
    '#F7DA64', '#FBA026', '#EB6B56', '#E25041', '#A38F84', '#EFEFEF', '#FFFFFF',
    '#FAC51C', '#F37934', '#D14841', '#B8312F', '#7C706B', '#D1D5D8', 'REMOVE'
  ],
  toolbarButtons: arrToolbarButtons,
  pluginsEnabled: [
    'align',
    'charCounter',
    // 'codeBeautifier',
    // 'codeView',
    'colors',
    'draggable',
    // 'embedly',
    'emoticons',
    'entities',
    'file',
    // 'fontFamily',
    'fontSize',
    'fullscreen',
    'fullscreenFix',
    'image',
    'inlineClass',
    // 'inlineStyle',
    'lineBreaker',
    'link',
    'lists',
    // 'paragraphFormat',
    // 'paragraphStyle',
    // 'quickInsert',
    // 'quote',
    'save',
    'table',
    'url',
    'video',
    // 'wordPaste',
    // 'save',
    // 'mailmerge',
    // 'custom_translation_dropdown',
  ],
  pasteDeniedAttrs: ['class', 'id'],
  pasteAllowedStyleProps: ['color', 'background', 'background-color'],
  // pasteAllowedStyleProps: ['color', 'background', 'background-color', 'position', 'width', 'height', 'margin-left', 'margin-right'],
};



/* original - toolbarButtons 
toolbarButtons: [
  'fullscreen',
  'bold',
  'italic',
  'underline',
  'strikeThrough',
  // 'subscript',
  // 'superscript',
  '|',
  // 'fontFamily',
  // 'fontSize', 
  'custom_fontsize_dropdown',
  'color',
  // 'inlineStyle',
  // 'inlineClass',
  // 'paragraphStyle',
  '|',
  'paragraphFormat',
  'align',
  'formatOL',
  'formatUL',
  'outdent',
  'indent',
  // 'quote',
  // '-',
  '|',
  'insertLink',
  // 'insertFile',
  // 'insertImage',
  'insertVideo',
  // 'embedly',
  'insertTable',
  // '|',
  'emoticons',
  // 'specialCharacters',
  // 'insertHR',
  // 'selectAll',
  // 'clearFormatting',
  // '|',
  // 'print',
  // 'spellChecker',
  // 'help',
  // 'html',
  '|',
  'undo',
  'redo',
  '|',
  'save',
  'load',
  '|',
  'custom_translation_dropdown',
  // 'mailmerge',
],
*/